import MetricRepository from '../../repositories/MetricRepository';

export default {
	namespaced: true,
	state: {},
	mutations: {},
	actions: {
		fetchDashboard ({ commit, getters }) {
			return MetricRepository.dashboardMetrics();
		},
		fetchGroup ({ commit, getters }, payload) {
			return MetricRepository.groupMetrics(payload.group);
		},
		fetchClient ({ commit, getters }, payload) {
			return MetricRepository.clientMetrics(payload.client);
		}
	},
	getters: {
	}
};
